import classNames from 'classnames';
var Pill = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, value = _a.value;
    var shown = children || value;
    return <>{shown && <span className={classNames('c-pill', className)}>{children || value}</span>}</>;
};
export default Pill;
